import React from 'react';

import { IconButton } from '@frontend/components';

const HeaderIconButton = React.forwardRef(function HeaderIconButton(
  { children, ...rest },
  ref,
) {
  return (
    <IconButton
      color="feature.onInteraction"
      transition="all 0.2s ease"
      ref={ref}
      _hover={{ bg: 'transparent', color: 'brand.secondary' }}
      _active={{ bg: 'transparent', color: 'brand.secondary' }}
      _focus={{ bg: 'transparent', color: 'brand.secondary', border: 'none' }}
      _focusVisible={{ outline: 'none !important' }}
      {...rest}
    >
      {children}
    </IconButton>
  );
});

export default HeaderIconButton;
